import Login from "../../page/Login";
import AdminLayout from "../AdminLayout";
import RoleManagement from "../pages/RoleManagement";
import ProfileAdmins from "../pages/ProfileAdmins";
import { Navigate } from "react-router-dom";
import AdminDashboard from "../pages/AdminDashboard";
import Transactions from "../pages/Transactions";

const AdminRoutes = [
  {
    path: "/admin",
    element: <Navigate to="/admin/login" replace />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboard />,
      },
      { path: "role-management", element: <RoleManagement /> },
      {
        path: "profile-admin",
        element: <ProfileAdmins />,
      },
      {
        path: "transactions",
        element: <Transactions />,
      },
    ],
  },
  {
    path: "/admin/login",
    element: <Login />,
  },
];

export default AdminRoutes;
